(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kkc-gifting-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Prices live in the "Gifting pricing" section on the same page.
  function readPrices() {
    var src = document.querySelector('[data-kkc-prices]');
    if (!src) return null;
    return {
      base: parseFloat(src.dataset.base) || 0,
      minimum: parseInt(src.dataset.minimum, 10) || 1,
      tiers: (src.dataset.tiers || '').split(',').filter(Boolean).map(function (t) {
        var p = t.split(':'); return { min: parseInt(p[0], 10), price: parseFloat(p[1]) };
      }).sort(function (a, b) { return b.min - a.min; }),
      options: Array.prototype.map.call(src.querySelectorAll('[data-price-option]'), function (r) {
        return {
          label: r.dataset.label,
          setup: parseFloat(r.dataset.setup) || 0,
          perSet: parseFloat(r.dataset.perSet) || 0,
          includedAt: parseInt(r.dataset.includedAt, 10) || 0,
          defaultOn: r.dataset.defaultOn === 'true'
        };
      })
    };
  }

  function initCalc(form) {
    if (form.kkcRender) { form.kkcRender(); return; }

    var depositPct = parseFloat(form.dataset.deposit) || 50;
    var quoteAbove = parseInt(form.dataset.quoteAbove, 10) || 0;
    var qtyEl = form.querySelector('[data-calc-qty]');
    var host = form.querySelector('[data-calc-options]');
    var tpl = form.querySelector('[data-calc-row]');
    var order = form.querySelector('[data-calc-order]');
    var note = form.querySelector('[data-calc-note]');
    var mailto = form.dataset.mailto;
    var sel = function (attr, key) { return form.querySelector('[' + attr + '="' + key + '"]'); };
    var rows = [];

    // (Re)build one checkbox row per option, keeping ticks by label across rebuilds.
    function buildRows(options) {
      var key = options.map(function (o) { return o.label; }).join('|');
      if (host.dataset.key === key) {
        rows.forEach(function (r, i) { r.opt = options[i]; });
        return;
      }
      var ticked = {};
      rows.forEach(function (r) { ticked[r.opt.label] = r.cb.disabled ? r.cb.dataset.wasChecked === '1' : r.cb.checked; });
      host.innerHTML = '';
      rows = options.map(function (o, i) {
        var el = tpl.content.firstElementChild.cloneNode(true);
        var cb = el.querySelector('[data-calc-check]');
        cb.name = 'opt-' + i;
        cb.checked = (o.label in ticked) ? ticked[o.label] : o.defaultOn;
        el.querySelector('[data-calc-label]').textContent = o.label;
        host.appendChild(el);
        return { el: el, cb: cb, opt: o };
      });
      host.dataset.key = key;
    }

    function render() {
      var prices = readPrices();
      if (!prices) {
        if (note) note.textContent = note.dataset.noteMissing;
        return;
      }
      buildRows(prices.options);

      var q = Math.max(1, Math.min(999, parseInt(qtyEl.value, 10) || 1));
      var per = prices.base;
      for (var i = 0; i < prices.tiers.length; i++) { if (q >= prices.tiers[i].min) { per = prices.tiers[i].price; break; } }
      var total = per * q;
      var under = q < prices.minimum;
      var over = quoteAbove > 0 && q > quoteAbove;
      var maxPer = per;
      rows.forEach(function (r) { maxPer = Math.max(maxPer, r.opt.perSet); });
      var guess = per + rows.reduce(function (s, r) { return s + r.opt.perSet + r.opt.setup / q; }, 0);
      var W = Math.max(money(maxPer).length, money(guess).length);
      var pad = function (n) { var m = money(n); return '$' + m.slice(1).padStart(W - 1, String.fromCharCode(0x2007)); };

      sel('data-calc-detail', 'sets').textContent = pad(per) + ' × ' + q;
      sel('data-calc-extra', 'sets').textContent = '';
      sel('data-calc-amt', 'sets').textContent = money(per * q);

      var picked = [];
      rows.forEach(function (r) {
        var cb = r.cb, o = r.opt;
        if (under) {
          if (!cb.disabled) { cb.dataset.wasChecked = cb.checked ? '1' : ''; cb.checked = false; cb.disabled = true; }
        } else if (cb.disabled) {
          cb.disabled = false; cb.checked = cb.dataset.wasChecked === '1';
        }
        var on = cb.checked;
        var included = o.includedAt > 0 && q >= o.includedAt;
        var amt = (included || under) ? 0 : o.perSet * q + o.setup;
        var d = r.el.querySelector('[data-calc-detail]');
        var x = r.el.querySelector('[data-calc-extra]');
        var a = r.el.querySelector('[data-calc-amt]');
        if (under) {
          d.textContent = '';
          x.textContent = 'from ' + prices.minimum + ' sets';
        } else {
          d.innerHTML = included ? '<s>' + pad(o.perSet) + ' × ' + q + '</s>' : pad(o.perSet) + ' × ' + q;
          x.textContent = included ? 'included at ' + o.includedAt + '+' : (o.setup > 0 ? '+ ' + money(o.setup) + ' setup' : '');
        }
        a.textContent = money(on ? amt : 0);
        r.el.classList.toggle('kkc-calc__row--off', under || !on);
        if (on && !under) { total += amt; picked.push(o.label.toLowerCase()); }
      });

      sel('data-calc-detail', 'total').textContent = pad(Math.round(total / q * 100) / 100);
      sel('data-calc-extra', 'total').textContent = 'per set';
      sel('data-calc-amt', 'total').textContent = money(total);

      if (order) {
        var body = q + ' sets' + (picked.length ? ', ' + picked.join(', ') : '') + (over ? '.' : '. Estimated total ' + money(total) + '.');
        var lead = over ? 'I would like a quote for: ' : 'I would like to order: ';
        var prompts = (form.dataset.emailPrompts || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        var lines = ['Hello Kathleen,', '', lead + body, ''];
        if (prompts.length) { if (form.dataset.emailIntro) lines.push(form.dataset.emailIntro, ''); lines = lines.concat(prompts, ['']); }
        order.setAttribute('href', mailto + '&body=' + encodeURIComponent(lines.join(String.fromCharCode(10))));
        order.textContent = over ? order.dataset.labelQuote : order.dataset.labelOrder;
      }
      if (note) {
        note.textContent = under
          ? note.dataset.noteUnder
          : over
          ? note.dataset.noteQuote
          : (depositPct + '% deposit of ' + money(Math.round(total * depositPct / 100 * 100) / 100) + ' to begin, balance before delivery. ' + note.dataset.noteTerms).trim();
      }
    }

    form.kkcRender = render;
    form.addEventListener('input', render);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    render();
  }

  function boot() {
    document.querySelectorAll('[data-kkc-calc]').forEach(initCalc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Re-read prices when either section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kkc-gifting-pricing"] && !Shopify.designMode) return;
  try {
    
(function () {
  // One-line fit for the fortune slips in the multicolumn section whose id ends in "__moments".
  function fitSlips() {
    var slips = document.querySelectorAll('[id$="__moments"] .multicolumn-card__info .rte p');
    slips.forEach(function (el) {
      var size = 18; el.style.fontSize = size + 'px';
      while (el.scrollWidth > el.clientWidth && size > 11) { size -= 0.5; el.style.fontSize = size + 'px'; }
    });
  }

  function boot() {
    fitSlips();
    window.addEventListener('resize', fitSlips);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSlips);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-application"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-wholesale-application]');
    if (!roots.length) return;

    roots.forEach(init);

    function init(root) {
      var form = root.querySelector('[data-wa-form]');
      var workerUrl = (root.getAttribute('data-worker-url') || '').replace(/\/+$/, '');
      var siteKey = root.getAttribute('data-turnstile-key') || '';
      var state = root.getAttribute('data-state');
      var errBox = root.querySelector('[data-wa-errors]');
      var okBox = root.querySelector('[data-wa-success]');
      var accountStep = root.querySelector('[data-wa-step="account"]');
      var businessStep = root.querySelector('[data-wa-step="business"]');
      var stepToken = null;
      var turnstileToken = null;
      var turnstileWidget = null;
      var turnstileEl = root.querySelector('[data-wa-turnstile]');

      /* Turnstile (explicit render so we control the callback) */
      function renderTurnstile() {
        if (!turnstileEl || !siteKey || !window.turnstile) return;
        turnstileWidget = window.turnstile.render(turnstileEl, {
          sitekey: siteKey,
          callback: function (t) { turnstileToken = t; },
          'expired-callback': function () { turnstileToken = null; },
          'error-callback': function () { turnstileToken = null; }
        });
      }
      if (siteKey) {
        if (window.turnstile) renderTurnstile(); else (window.kkcTurnstileQueue = window.kkcTurnstileQueue || []).push(renderTurnstile);
      }
      function resetTurnstile() {
        turnstileToken = null;
        if (window.turnstile && turnstileWidget !== null) { try { window.turnstile.reset(turnstileWidget); } catch (e) {} }
      }

      /* Country -> state/province, driven by Shopify's data-provinces on each option */
      var taxRegions = [];
      root.querySelectorAll('[data-wa-address]').forEach(function (block) {
        var country = block.querySelector('[data-wa-country]');
        var has = block.querySelector('[data-wa-has-provinces]');
        var wrap = block.querySelector('[data-wa-province-wrap]');
        var prov = block.querySelector('[data-wa-province]');
        var us = country.querySelector('option[value="United States"]');
        if (us && country.selectedIndex <= 0) us.selected = true;
        if (!taxRegions.length) {
          ['United States', 'Canada'].forEach(function (name) {
            var o = country.querySelector('option[value="' + name + '"]');
            if (!o) return;
            try { taxRegions = taxRegions.concat(JSON.parse(o.getAttribute('data-provinces') || '[]')); } catch (e) {}
          });
        }
        function update() {
          var opt = country.options[country.selectedIndex];
          var list = [];
          try { list = opt ? JSON.parse(opt.getAttribute('data-provinces') || '[]') : []; } catch (e) {}
          prov.innerHTML = '';
          if (list.length) {
            addOption(prov, '', root.getAttribute('data-label-select'));
            list.forEach(function (p) { addOption(prov, p[0], p[1]); });
            wrap.hidden = false; has.value = '1'; prov.required = !block.hasAttribute('data-wa-billing') || !billingSame.checked;
          } else {
            wrap.hidden = true; has.value = ''; prov.required = false;
          }
        }
        country.addEventListener('change', update);
        block._waUpdate = update;
      });

      /* Tax registration state: US states and Canadian provinces, plus "outside" */
      var taxState = root.querySelector('[data-wa-tax-state]');
      addOption(taxState, '', root.getAttribute('data-label-select'));
      taxRegions.forEach(function (p) { addOption(taxState, p[1], p[1]); });
      addOption(taxState, 'Outside the United States', root.getAttribute('data-label-outside-us'));

      /* Billing toggle */
      var billingSame = root.querySelector('[data-wa-billing-same]');
      var billingBlock = root.querySelector('[data-wa-billing]');
      function toggleBilling() {
        billingBlock.hidden = billingSame.checked;
        billingBlock.querySelectorAll('input, select').forEach(function (el) {
          el.disabled = billingSame.checked;
          if (/address1|city|zip|country$/.test(el.name)) el.required = !billingSame.checked;
        });
        if (!billingSame.checked) billingBlock._waUpdate();
      }
      billingSame.addEventListener('change', toggleBilling);

      /* Tax review toggle: hide ID + file, show note */
      var taxReview = root.querySelector('[data-wa-tax-review]');
      var taxNoteWrap = root.querySelector('[data-wa-tax-note]');
      function toggleTax() {
        var review = taxReview.checked;
        root.querySelectorAll('[data-wa-tax-doc]').forEach(function (el) {
          el.hidden = review;
          el.querySelectorAll('input').forEach(function (i) { i.disabled = review; i.required = !review; });
        });
        taxNoteWrap.hidden = !review;
        var note = taxNoteWrap.querySelector('textarea');
        note.disabled = !review; note.required = review;
      }
      taxReview.addEventListener('change', toggleTax);

      root.querySelectorAll('[data-wa-address]').forEach(function (b) { b._waUpdate(); });
      toggleBilling();
      toggleTax();

      /* Validation helpers */
      function firstInvalid(scope) {
        var bad = null;
        scope.querySelectorAll('input, select, textarea').forEach(function (el) {
          if (bad || el.disabled || el.closest('[hidden]')) return;
          if (!el.checkValidity()) bad = el;
        });
        return bad;
      }
      function showErrors(list) {
        errBox.innerHTML = '<ul>' + list.map(function (m) { return '<li>' + escapeHtml(String(m)) + '</li>'; }).join('') + '</ul>';
        errBox.hidden = false;
        errBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      function clearErrors() { errBox.hidden = true; errBox.innerHTML = ''; }
      function escapeHtml(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function busy(btn, on) {
        if (on) { btn.dataset.label = btn.textContent; btn.textContent = root.getAttribute('data-msg-sending'); btn.disabled = true; }
        else { btn.textContent = btn.dataset.label || btn.textContent; btn.disabled = false; }
      }
      function needTurnstile() {
        if (siteKey && !turnstileToken) { showErrors([root.getAttribute('data-msg-bot')]); return true; }
        return false;
      }
      async function post(path, body, isJson) {
        var res = await fetch(workerUrl + path, {
          method: 'POST',
          headers: isJson ? { 'Content-Type': 'application/json' } : undefined,
          body: isJson ? JSON.stringify(body) : body
        });
        var data = {};
        try { data = await res.json(); } catch (e) {}
        return { ok: res.ok && data.ok, status: res.status, data: data };
      }

      /* Step 1: account */
      var continueBtn = root.querySelector('[data-wa-continue]');
      if (continueBtn) {
        continueBtn.addEventListener('click', async function () {
          clearErrors();
          root.querySelector('[data-wa-signin]').hidden = true;
          if (!workerUrl) { showErrors([root.getAttribute('data-msg-config')]); return; }
          var bad = firstInvalid(accountStep);
          if (bad) { bad.reportValidity(); return; }
          if (needTurnstile()) return;
          busy(continueBtn, true);
          try {
            var r = await post('/account', {
              email: accountStep.querySelector('[name="email"]').value.trim(),
              firstName: accountStep.querySelector('[name="firstName"]').value.trim(),
              lastName: accountStep.querySelector('[name="lastName"]').value.trim(),
              phone: accountStep.querySelector('[name="phone"]').value.trim(),
              turnstileToken: turnstileToken
            }, true);
            if (r.ok) {
              stepToken = r.data.token;
              accountStep.hidden = true;
              businessStep.hidden = false;
              businessStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
              var first = businessStep.querySelector('input:not([type="hidden"])');
              if (first) first.focus({ preventScroll: true });
            } else if (r.data.code === 'ACCOUNT_EXISTS') {
              root.querySelector('[data-wa-signin]').hidden = false;
              resetTurnstile();
            } else {
              showErrors(r.data.errors || [r.data.error || root.getAttribute('data-msg-network')]);
              resetTurnstile();
            }
          } catch (e) {
            showErrors([root.getAttribute('data-msg-network')]);
            resetTurnstile();
          } finally {
            busy(continueBtn, false);
          }
        });
      }

      /* Step 2: business */
      var submitBtn = root.querySelector('[data-wa-submit]');
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        clearErrors();
        if (!workerUrl) { showErrors([root.getAttribute('data-msg-config')]); return; }
        var bad = firstInvalid(businessStep);
        if (bad) { bad.reportValidity(); return; }
        if (state === 'customer' && needTurnstile()) return;
        var fd = new FormData(form);
        ['firstName', 'lastName', 'email'].forEach(function (k) { fd.delete(k); });
        if (state === 'anonymous') {
          if (!stepToken) { showErrors([root.getAttribute('data-msg-network')]); return; }
          fd.append('token', stepToken);
        } else {
          fd.append('customerId', root.getAttribute('data-customer-id'));
          fd.append('email', root.getAttribute('data-customer-email'));
          fd.append('turnstileToken', turnstileToken || '');
        }
        busy(submitBtn, true);
        try {
          var r = await post('/company', fd, false);
          if (r.ok) {
            businessStep.hidden = true;
            var msg = root.getAttribute(state === 'anonymous' ? 'data-msg-success-anonymous' : 'data-msg-success-customer');
            if (r.data.fileFailed) msg += ' ' + root.getAttribute('data-msg-file-failed');
            okBox.textContent = msg;
            okBox.hidden = false;
            okBox.focus();
            okBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            showErrors(r.data.errors || [r.data.error || root.getAttribute('data-msg-network')]);
            if (state === 'customer') resetTurnstile();
          }
        } catch (err) {
          showErrors([root.getAttribute('data-msg-network')]);
          if (state === 'customer') resetTurnstile();
        } finally {
          busy(submitBtn, false);
        }
      });

      function addOption(select, value, label) {
        var o = document.createElement('option');
        o.value = value; o.textContent = label; select.appendChild(o);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
